const mod = crateImports["@xing-com/crate-communication-tracking"];
const { SCHEMA_VERSION,useExitIntentTracking,useTracking,useViewerDataEventual } = mod;
export { SCHEMA_VERSION,useExitIntentTracking,useTracking,useViewerDataEventual };
export default mod.default ?? mod;